import Vue from 'vue';

import App from './app/App.vue';
import './axios';
import './filters';
import './fonts';
import './spinner';
import './html2pdf';
import i18n from './i18n';
import router from './router';
import store from './store';
import './validate';
import './calendar-date-picker';
import Vue2Filters from 'vue2-filters';
import Scrollspy from 'vue2-scrollspy';
import VueFormWizard from 'vue-form-wizard';
import 'vue-form-wizard/dist/vue-form-wizard.min.css';

Vue.config.productionTip = false;

Vue.use(Scrollspy, {
  'v-scroll-spy': {
    data: 'section'
  }
});
Vue.use(Vue2Filters);

Vue.use(VueFormWizard);

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app');
